<div class="main">
    <div *ngIf="showLoader" class="loader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="mobile_responsive" style="display: none;">
        <div class="head">
          <div class="title">
            <div class="label">
              {{'INPLANT.inPlantVehicles'| translate}}
            </div>
            <div class="download_btn" (click)="download();">
              <img src="assets/download-icon-mobile.svg" alt="">
              <span class="download">{{'INPLANT.download'| translate}}</span>
            </div>
          </div>
          <div class="filter">
            <div class="all_unit">
              <div class="all_unit_title">
                {{'INPLANT.allUnit'| translate}}
              </div>
              <div class="all_unit_toggle">
                <mat-slide-toggle (change)="allUnitData()">
                </mat-slide-toggle>
              </div>
            </div>
            <div class="mobile_filters">
              <div class="date_filter">
                <div class="input">
                  <div class="label">
                    {{ "REPORTS.from" | translate }}
                  </div>
                  <input type="text" class="inputField" placeholder="Date" [(ngModel)]="fromDate"
                    (click)="fromDateInput4.open()" [matDatepicker]="fromDateInput4" />
                  <mat-datepicker #fromDateInput4 (closed)="getInplantvehicles()"></mat-datepicker>
                </div>
              </div>
              <hr class="line">
              <div class="date_filter">
                <div class="input">
                  <div class="label">
                    {{ "REPORTS.to" | translate }}
                  </div>
                  <input type="text" class="inputField" placeholder="Date" [(ngModel)]="toDate"
                    (click)="toDateInput4.open()" [matDatepicker]="toDateInput4" />
                  <mat-datepicker #toDateInput4 (closed)="getInplantvehicles()"></mat-datepicker>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header">
        <div class="left">
          <div class="label">
            {{'INPLANT.inPlantVehicles'| translate}}
          </div>
        </div>
      </div>
      <div class="filters">
        <div class="filter">
          <div class="label">
            {{ "REPORTS.from" | translate }}
          </div>
          <div class="input">
            <input type="text" class="inputField" placeholder="Date" [(ngModel)]="fromDate"
              (click)="fromDateInput3.open()" [matDatepicker]="fromDateInput3" />
            <mat-datepicker #fromDateInput3 (closed)="getInplantvehicles()"></mat-datepicker>
            <span class="material-icons dateIcon"> date_range </span>
          </div>
        </div>
        <div class="filter">
          <div class="label">
            {{ "REPORTS.to" | translate }}
          </div>
          <div class="input">
            <input type="text" class="inputField" placeholder="Date" [(ngModel)]="toDate" (click)="toDateInput3.open()"
              [matDatepicker]="toDateInput3" />
            <mat-datepicker #toDateInput3 (closed)="getInplantvehicles()"></mat-datepicker>
            <span class="material-icons dateIcon"> date_range </span>
          </div>
        </div>
        <div class="refresh_btn">
          <mat-icon class=""  (click)="getInplantvehicles()">refresh</mat-icon>
        </div>
      </div>
      <div class="body">
        <div class="table">
          <table mat-table [dataSource]="inPlantvehicles" *ngIf="inPlantvehicles && inPlantvehicles.length;else noOrders">
  
            <ng-container matColumnDef="sno">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.sno'| translate}} </th>
              <td mat-cell *matCellDef="let element; let i = index"> {{i+1}} </td>
            </ng-container>
  
            <ng-container matColumnDef="gate_entry_no">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.gateEntry'| translate}} </th>
              <td mat-cell *matCellDef="let element">{{element.entry_no}}</td>
            </ng-container>
  
  
            <ng-container matColumnDef="vehicle_details">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.vehicleDetails'| translate}} </th>
              <td mat-cell *matCellDef="let element">
                <!-- {{element.vehicle}}<br />{{element.vehicleCapacity}} -->
                <div *ngIf="element.tracker" (click)="$event.stopPropagation();">
                  <a href="{{ element.tracker }}" target="_blank">
                    <span>
                      {{element.vehicle}}<br />{{element.vehicleCapacity}} MT
                    </span>
                  </a>
                </div>
                <div *ngIf="!element.tracker">
                  {{element.vehicle}}<br />{{element.vehicleCapacity}} MT
                </div>
              </td>
            </ng-container>
  
            <ng-container matColumnDef="plant_ageing">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.plantAgeing'| translate}} </th>
              <td mat-cell *matCellDef="let element" matTooltip={{element.gateintime}}> {{element.aging}} </td>
            </ng-container>
  
            <ng-container matColumnDef="customer_details">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.customerDetails'| translate}} </th>
              <td mat-cell *matCellDef="let element">{{element.customer_name}} <br/> {{element.destination}} </td>
            </ng-container>
  
            <ng-container matColumnDef="carrier_details">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.shipperDetails'| translate}} </th>
              <td mat-cell *matCellDef="let element" matTooltip={{element.supportnumber}}>
                {{element.shipper.parent_name}}<br />{{element.carriertype}}</td>
            </ng-container>
  
            <ng-container matColumnDef="driver_details">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.driverDetails'| translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.name}}<br />{{element.mobile}}</td>
            </ng-container>
  
            <ng-container matColumnDef="od_status">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.odStatus'| translate}} </th>
              <td mat-cell *matCellDef="let element">{{element.obdNumber}} </td>
            </ng-container>
            
            <ng-container matColumnDef="desiredweight">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.desiredweight'| translate}} </th>
              <td mat-cell *matCellDef="let element">{{element.desiredWeight}} </td>
            </ng-container>
  
            <ng-container matColumnDef="material">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.material'| translate}} </th>
              <td mat-cell *matCellDef="let element"> {{element.material}} </td>
            </ng-container>
  
            <ng-container matColumnDef="remarks">
              <th mat-header-cell *matHeaderCellDef> {{'INPLANT.remarks'| translate}} </th>
              <td mat-cell *matCellDef="let element" matTooltip={{element.remarks}}> {{element.remarks[0]}} </td>
            </ng-container>
  
            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"  [ngClass]="{'highlightTableColor': selectedRowIndex == i}" (click)="getOrderStatus(row,i);"></tr>
          </table>
        </div>
        <mat-paginator fixed [length]="inPlantvehicles ? totalvehicles : 0" [pageSize]="25"
          [pageSizeOptions]="[25, 50, 100]" [showFirstLastButtons]="true" (page)="pageNavigate($event)"></mat-paginator>
        
      </div>
      <ng-template #noOrders>
        <div class="noOrders" style="padding-top: 30px;display: flex;justify-content: center;margin-top: 10%;">
          {{'INPLANT.no_data' | translate}}
        </div>
      </ng-template>
    </div>
  </div>
  
